import { render, staticRenderFns } from "./EditClassroom.vue?vue&type=template&id=a6a6a390&scoped=true&"
import script from "./EditClassroom.vue?vue&type=script&lang=js&"
export * from "./EditClassroom.vue?vue&type=script&lang=js&"
import style0 from "./EditClassroom.vue?vue&type=style&index=0&id=a6a6a390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a6a390",
  null
  
)

export default component.exports